<template>
   <Teleport to="body">
    <div class="modal fade" id="noPermissionModal" tabindex="-1">
    <div class="modal-dialog modal-dialog-centered mx-auto" style="width: 21.25rem">
      <div class="modal-content p-24">
        <div
          class="modal-body text-00365b fs-14 d-flex flex-column gap-12 p-0 align-items-center"
        >
          <img
            src="../../../assets/landing/warning.svg"
            alt="warning"
            style="width: 5rem; height: 5rem"
          />
          <span v-html="noPermissionMessage"></span>
          <!-- Scanat Webは法人プラン（Plan B以上）のオプション機能です。アプリでスキャンしたモデルをブラウザ上で閲覧・操作でき、モデルリンクを作成してScanatユーザー以外にも共有できる便利な機能です。</br>
          <span>詳細は<a href="https://www.natincs.com/contact/" style="text-decoration:underline;">お問い合わせフォーム</a>、または営業担当までお問い合わせください。</span> -->
        </div>
        <div class="modal-footer border-0 p-0 mt-24">
          <button
            type="button"
            class="btn-secondary small border-0 m-0 text-white fw-bold fs-14 w-100 b-r-4 bg-primary"
            data-mdb-dismiss="modal"
            style="padding: 5px 1rem; font-weight: 500"
          >
            {{ $t('common.close') }}
          </button>
        </div>
      </div>
    </div>
  </div>
   </Teleport>
</template>

<script setup>
    import { computed, Teleport, onMounted, onUnmounted } from 'vue'
    import i18n from '../../../lang'
    const $t = i18n.global.t
    const noPermissionMessage = computed(() => {
        return $t('landing.alertNoPlan').replace(
            /<link>(.*?)<\/link>/g,
            '<a target="_blank" style="text-decoration:underline;" href="https://www.natincs.com/contact/">$1</a>'
        )
    })

    const handleModalClose = () => {
        if (!window.location.href.includes('models.html')) return
        window.location.href = '/landing.html'
    }

    onMounted(() => {
        const modal = document.getElementById('noPermissionModal')
        if (modal) {
            modal.addEventListener('hidden.mdb.modal', handleModalClose)
        }
    })

    onUnmounted(() => {
        const modal = document.getElementById('noPermissionModal')
        if (modal) {
            modal.removeEventListener('hidden.mdb.modal', handleModalClose)
        }
    })
</script>